import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { SupportAgentTicket } from "@src/types/support";

export interface PatchTicketAssigneeResult {
  success: boolean;
  data?: SupportAgentTicket;
  error?: string;
}

export const patchTicketAssigneeUseCase = async (
  ticketId: string,
  newAssigneeId: string | null,
  handoverText?: string,
  options?: { handledByAiChatbot?: boolean },
): Promise<PatchTicketAssigneeResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchTicketAssignee(
      namespace,
      ticketId,
      newAssigneeId,
      handoverText,
      options,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update ticket assignee")
        .message,
    };
  }
};
